/**
 * Project sidebar badge store.
 * Written by `<ProjectBadgeSubscriber />`; read by `projectsMenu`.
 */

import { create } from 'zustand';

interface ProjectBadgesState {
  myProjects: number;
  overdueMilestones: number;
  setFromMetrics: (m: Partial<Pick<ProjectBadgesState, 'myProjects' | 'overdueMilestones'>>) => void;
  applyDelta: (m: Partial<Pick<ProjectBadgesState, 'myProjects' | 'overdueMilestones'>>) => void;
  reset: () => void;
}

const EMPTY = { myProjects: 0, overdueMilestones: 0 };
const clamp = (n: number) => (n < 0 ? 0 : n);

export const useProjectBadgesStore = create<ProjectBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) =>
    set({
      myProjects: clamp(m.myProjects ?? 0),
      overdueMilestones: clamp(m.overdueMilestones ?? 0),
    }),
  applyDelta: (m) =>
    set((state) => ({
      myProjects: clamp(state.myProjects + (m.myProjects ?? 0)),
      overdueMilestones: clamp(state.overdueMilestones + (m.overdueMilestones ?? 0)),
    })),
  reset: () => set(EMPTY),
}));
